
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view-side-by-side",
      function () {
        return require("private-next-pages/view-side-by-side.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view-side-by-side"])
      });
    }
  